/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfoAndRef,
  PersonNameInfoAndRefOptional,
  PersonNameInfoAndRefMetaI,
  PersonNameInfoAndRefTrackedI,
} from "./person-name-info-and-ref";
import {
  PersonNameInfoAndRefTracked,
  PersonNameInfoAndRefMeta,
} from "./person-name-info-and-ref";

/**
 *
 * @export
 * @interface LineItemCalculated
 */
export interface LineItemCalculatedOptional {
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof LineItemCalculated
   */
  personInfo?: PersonNameInfoAndRefOptional;
  /**
   * Total value (in cents) of all discounts applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountDiscountsBaseCents?: number;
  /**
   * Total value (in cents) of all discounts applied to all units of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountDiscountsTotalCents?: number;
  /**
   * Total value (in cents) of all taxes applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountTaxesBaseCents?: number;
  /**
   * Total value (in cents) of all taxes applied to all units of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountTaxesTotalCents?: number;
  /**
   * Amount of money to refund (in cents)
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountToRefundCents?: number;
  /**
   * Amount of money successfully refunded
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemCalculated
   */
  displayOrder?: number;
}

export interface LineItemCalculated extends LineItemCalculatedOptional {
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof LineItemCalculated
   */
  personInfo?: PersonNameInfoAndRef;
  /**
   * Total value (in cents) of all discounts applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountDiscountsBaseCents?: number;
  /**
   * Total value (in cents) of all discounts applied to all units of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountDiscountsTotalCents?: number;
  /**
   * Total value (in cents) of all taxes applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountTaxesBaseCents?: number;
  /**
   * Total value (in cents) of all taxes applied to all units of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountTaxesTotalCents?: number;
  /**
   * Amount of money to refund (in cents)
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountToRefundCents?: number;
  /**
   * Amount of money successfully refunded
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemCalculated
   */
  displayOrder?: number;
}

export interface LineItemCalculatedTrackedI {
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof LineItemCalculated
   */
  personInfo?: PersonNameInfoAndRefTrackedI;
  personInfoIsSet: boolean;
  /**
   * Total value (in cents) of all discounts applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountDiscountsBaseCents?: number;
  amountDiscountsBaseCentsIsSet: boolean;
  /**
   * Total value (in cents) of all discounts applied to all units of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountDiscountsTotalCents?: number;
  amountDiscountsTotalCentsIsSet: boolean;
  /**
   * Total value (in cents) of all taxes applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountTaxesBaseCents?: number;
  amountTaxesBaseCentsIsSet: boolean;
  /**
   * Total value (in cents) of all taxes applied to all units of this line item
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountTaxesTotalCents?: number;
  amountTaxesTotalCentsIsSet: boolean;
  /**
   * Amount of money to refund (in cents)
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountToRefundCents?: number;
  amountToRefundCentsIsSet: boolean;
  /**
   * Amount of money successfully refunded
   * @type {number}
   * @memberof LineItemCalculated
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemCalculated
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
}

transformDatesMap.set(
  "LineItemCalculated",
  function (model: LineItemCalculated) {
    const transformDatespersonInfo = transformDatesMap.get(
      "PersonNameInfoAndRef",
    );
    if (transformDatespersonInfo && model.personInfo) {
      transformDatespersonInfo(model.personInfo);
    }
  },
);

export type LineItemCalculatedMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personInfo: PropertyMeta<PersonNameInfoAndRefMetaI>;
  //isDate: false
  //isDatetime: false
  amountDiscountsBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountDiscountsTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
}>;

export var LineItemCalculatedMeta: LineItemCalculatedMetaI =
  {} as LineItemCalculatedMetaI;
LineItemCalculatedMeta = typeMeta("LineItemCalculated", {
  personInfo: propertyMeta(
    "personInfo",
    false,
    false,
    false,
    PersonNameInfoAndRefMeta,
  ),
  amountDiscountsBaseCents: propertyMeta(
    "amountDiscountsBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountDiscountsTotalCents: propertyMeta(
    "amountDiscountsTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesBaseCents: propertyMeta(
    "amountTaxesBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesTotalCents: propertyMeta(
    "amountTaxesTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToRefundCents: propertyMeta(
    "amountToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = LineItemCalculatedMeta;

registerMeta(() => {});

export class LineItemCalculatedTracked implements LineItemCalculatedTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  personInfo__I?: PersonNameInfoAndRefTracked = undefined;
  personInfoIsSet: boolean = false;
  set personInfo(v: undefined | PersonNameInfoAndRefTracked) {
    if (v !== undefined) {
      this.personInfo__I = v;
      this.personInfoIsSet = true;
    } else {
      this.personInfo__I = v || undefined;
      this.personInfoIsSet = false;
    }
    this.changeTracker = true;
  }
  get personInfo() {
    return this.personInfo__I;
  }
  amountDiscountsBaseCents__I?: number = undefined;
  amountDiscountsBaseCentsIsSet: boolean = false;
  set amountDiscountsBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsBaseCents__I = v;
      this.amountDiscountsBaseCentsIsSet = true;
    } else {
      this.amountDiscountsBaseCents__I = v || undefined;
      this.amountDiscountsBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsBaseCents() {
    return this.amountDiscountsBaseCents__I;
  }
  amountDiscountsTotalCents__I?: number = undefined;
  amountDiscountsTotalCentsIsSet: boolean = false;
  set amountDiscountsTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsTotalCents__I = v;
      this.amountDiscountsTotalCentsIsSet = true;
    } else {
      this.amountDiscountsTotalCents__I = v || undefined;
      this.amountDiscountsTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsTotalCents() {
    return this.amountDiscountsTotalCents__I;
  }
  amountTaxesBaseCents__I?: number = undefined;
  amountTaxesBaseCentsIsSet: boolean = false;
  set amountTaxesBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesBaseCents__I = v;
      this.amountTaxesBaseCentsIsSet = true;
    } else {
      this.amountTaxesBaseCents__I = v || undefined;
      this.amountTaxesBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesBaseCents() {
    return this.amountTaxesBaseCents__I;
  }
  amountTaxesTotalCents__I?: number = undefined;
  amountTaxesTotalCentsIsSet: boolean = false;
  set amountTaxesTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesTotalCents__I = v;
      this.amountTaxesTotalCentsIsSet = true;
    } else {
      this.amountTaxesTotalCents__I = v || undefined;
      this.amountTaxesTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesTotalCents() {
    return this.amountTaxesTotalCents__I;
  }
  amountToRefundCents__I?: number = undefined;
  amountToRefundCentsIsSet: boolean = false;
  set amountToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundCents__I = v;
      this.amountToRefundCentsIsSet = true;
    } else {
      this.amountToRefundCents__I = v || undefined;
      this.amountToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundCents() {
    return this.amountToRefundCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  constructor(config?: LineItemCalculatedOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personInfo?.setIds();
  }
  assignFrom(
    config: LineItemCalculatedOptional,
    options?: AssignOptions,
  ): LineItemCalculatedTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.personInfo &&
      this.personInfoApplyFilter(optionsRequired.filter)
    ) {
      this.personInfo = new PersonNameInfoAndRefTracked(
        config.personInfo,
        options,
      );
      if (optionsRequired.unassign) this.personInfoIsSet = false;
      else this.personInfoIsSet = true;
    }
    if (
      config.amountDiscountsBaseCents &&
      this.amountDiscountsBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsBaseCents = config.amountDiscountsBaseCents;
      if (optionsRequired.unassign) this.amountDiscountsBaseCentsIsSet = false;
      else this.amountDiscountsBaseCentsIsSet = true;
    }
    if (
      config.amountDiscountsTotalCents &&
      this.amountDiscountsTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsTotalCents = config.amountDiscountsTotalCents;
      if (optionsRequired.unassign) this.amountDiscountsTotalCentsIsSet = false;
      else this.amountDiscountsTotalCentsIsSet = true;
    }
    if (
      config.amountTaxesBaseCents &&
      this.amountTaxesBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesBaseCents = config.amountTaxesBaseCents;
      if (optionsRequired.unassign) this.amountTaxesBaseCentsIsSet = false;
      else this.amountTaxesBaseCentsIsSet = true;
    }
    if (
      config.amountTaxesTotalCents &&
      this.amountTaxesTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesTotalCents = config.amountTaxesTotalCents;
      if (optionsRequired.unassign) this.amountTaxesTotalCentsIsSet = false;
      else this.amountTaxesTotalCentsIsSet = true;
    }
    if (
      config.amountToRefundCents &&
      this.amountToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundCents = config.amountToRefundCents;
      if (optionsRequired.unassign) this.amountToRefundCentsIsSet = false;
      else this.amountToRefundCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemCalculatedTrackedI {
    const cloned = {} as LineItemCalculatedTrackedI;
    if (
      this.personInfoIsSetDeep() &&
      this.personInfoApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personInfoIsSet = true;
      cloned.personInfo = this.personInfo?.removeUnset(filter);
    } else {
      //cloned.personInfoIsSet = false
    }
    if (
      this.amountDiscountsBaseCentsIsSetDeep() &&
      this.amountDiscountsBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsBaseCentsIsSet = true;
      cloned.amountDiscountsBaseCents = this.amountDiscountsBaseCents;
    } else {
      //cloned.amountDiscountsBaseCentsIsSet = false
    }
    if (
      this.amountDiscountsTotalCentsIsSetDeep() &&
      this.amountDiscountsTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsTotalCentsIsSet = true;
      cloned.amountDiscountsTotalCents = this.amountDiscountsTotalCents;
    } else {
      //cloned.amountDiscountsTotalCentsIsSet = false
    }
    if (
      this.amountTaxesBaseCentsIsSetDeep() &&
      this.amountTaxesBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesBaseCentsIsSet = true;
      cloned.amountTaxesBaseCents = this.amountTaxesBaseCents;
    } else {
      //cloned.amountTaxesBaseCentsIsSet = false
    }
    if (
      this.amountTaxesTotalCentsIsSetDeep() &&
      this.amountTaxesTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesTotalCentsIsSet = true;
      cloned.amountTaxesTotalCents = this.amountTaxesTotalCents;
    } else {
      //cloned.amountTaxesTotalCentsIsSet = false
    }
    if (
      this.amountToRefundCentsIsSetDeep() &&
      this.amountToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundCentsIsSet = true;
      cloned.amountToRefundCents = this.amountToRefundCents;
    } else {
      //cloned.amountToRefundCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemCalculatedTrackedI {
    if (!this.personInfoApplyFilter(filter)) this.personInfoIsSet = false;
    this.personInfo?.unassignAll(filter);

    if (!this.amountDiscountsBaseCentsApplyFilter(filter))
      this.amountDiscountsBaseCentsIsSet = false;

    if (!this.amountDiscountsTotalCentsApplyFilter(filter))
      this.amountDiscountsTotalCentsIsSet = false;

    if (!this.amountTaxesBaseCentsApplyFilter(filter))
      this.amountTaxesBaseCentsIsSet = false;

    if (!this.amountTaxesTotalCentsApplyFilter(filter))
      this.amountTaxesTotalCentsIsSet = false;

    if (!this.amountToRefundCentsApplyFilter(filter))
      this.amountToRefundCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    return this;
  }
  personInfoApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.personInfo,
      LineItemCalculatedMeta,
      this.personInfo,
      this,
    );
  }
  personInfoIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personInfoIsSet && this.personInfoApplyFilter(filter)) return true;
    return this.personInfo?.anySet(filter) == true;

    return false;
  }
  amountDiscountsBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.amountDiscountsBaseCents,
      LineItemCalculatedMeta,
      this.amountDiscountsBaseCents,
      this,
    );
  }
  amountDiscountsBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsBaseCentsIsSet &&
      this.amountDiscountsBaseCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountDiscountsTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.amountDiscountsTotalCents,
      LineItemCalculatedMeta,
      this.amountDiscountsTotalCents,
      this,
    );
  }
  amountDiscountsTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsTotalCentsIsSet &&
      this.amountDiscountsTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.amountTaxesBaseCents,
      LineItemCalculatedMeta,
      this.amountTaxesBaseCents,
      this,
    );
  }
  amountTaxesBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountTaxesBaseCentsIsSet &&
      this.amountTaxesBaseCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.amountTaxesTotalCents,
      LineItemCalculatedMeta,
      this.amountTaxesTotalCents,
      this,
    );
  }
  amountTaxesTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountTaxesTotalCentsIsSet &&
      this.amountTaxesTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.amountToRefundCents,
      LineItemCalculatedMeta,
      this.amountToRefundCents,
      this,
    );
  }
  amountToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundCentsIsSet &&
      this.amountToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.amountRefundedCents,
      LineItemCalculatedMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemCalculatedMeta.displayOrder,
      LineItemCalculatedMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personInfoIsSetDeep(filter)) return true;
    if (this.amountDiscountsBaseCentsIsSetDeep(filter)) return true;
    if (this.amountDiscountsTotalCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesBaseCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesTotalCentsIsSetDeep(filter)) return true;
    if (this.amountToRefundCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
